export default __webpack_public_path__ + "static/media/evo-title-en.a8ed4b5a.webp";